import { render, staticRenderFns } from "./SelectStudents.vue?vue&type=template&id=50e95948"
import script from "./SelectStudents.vue?vue&type=script&lang=js"
export * from "./SelectStudents.vue?vue&type=script&lang=js"
import style0 from "./SelectStudents.vue?vue&type=style&index=0&id=50e95948&prod&lang=less"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports